import {
  useRecaptcha
} from "../chunk-VFFO7X2Y.mjs";
import {
  appendCaptcha,
  resolveCaptcha
} from "../chunk-UELQYFJ7.mjs";
import {
  RECAPTCHA_SCRIPT_ID,
  generateRecaptchaToken,
  loadRecaptchaScript
} from "../chunk-ZD2ESESY.mjs";
import "../chunk-G4NYY657.mjs";
import {
  getCaptchaLocale,
  getCaptchaProvider,
  hasPresolvedGeeTest,
  setCaptchaContext,
  setPresolvedGeeTest,
  takePresolvedGeeTest,
  useCaptchaLocale,
  useCaptchaProvider,
  usePresolvedGeeTest
} from "../chunk-P2B2TNGX.mjs";
import "../chunk-JHUVX63K.mjs";
import "../chunk-IITKCRXL.mjs";
import {
  __objRest
} from "../chunk-RGHW4PYM.mjs";

// src/grecaptcha/WithGrecaptcha.tsx
var WithGrecaptcha = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  useRecaptcha(props);
  return children;
};
export {
  RECAPTCHA_SCRIPT_ID,
  WithGrecaptcha,
  appendCaptcha,
  generateRecaptchaToken,
  getCaptchaLocale,
  getCaptchaProvider,
  hasPresolvedGeeTest,
  loadRecaptchaScript,
  resolveCaptcha,
  setCaptchaContext,
  setPresolvedGeeTest,
  takePresolvedGeeTest,
  useCaptchaLocale,
  useCaptchaProvider,
  usePresolvedGeeTest,
  useRecaptcha
};
//# sourceMappingURL=index.mjs.map